/**
 * PLEASE READ BEFORE ADDING A NEW FEATURE FLAG:
 * 1. Add your FF to the AMPLITUDE_FF_LIST list at the bottom to help keep track of all the FFs in the app
 * 2. If you want to use your FF in the Amplitude context(which means it gets fetched on app load), add it to the AMPLITUDE_CONTEXT_FLAGS_LIST & AMPLITUDE_CONTEXT_FFS below
 * PLEASE DO NOT ADD TO THE AMPLITUDE CONTEXT if you want to bucket the FF in a component
 * 3. Opendoor webviews:
 * -  You want the FF to appear on the Opendoor mobile app webviews: add it to the WEBVIEW_FF_ALLOWLIST below
 * -  You don't want it to appear on the Opendoor mobile app webviews: add it to the WEBVIEW_FF_OPT_OUT_LIST below
 */
export const coreExpNovoAuth = 'core-exp-2024-04-novo-auth';
export const agentLedAssessments = 'seller-24-05-longterm-agent-led-assessments';

/**
 * WARNING!!!!!!!!
 * These feature flags are fetched on app load from experimentation context
 * DO NOT add to this list if you are calling getAmplitudeFF in a component
 */
export enum AMPLITUDE_CONTEXT_FLAGS_LIST {
  homebuilderExtendedCloseOfEscrow = 'seller-23-10-rollout-hb-extended-coe',
  closingDashboardNovo = 'seller-05-04-rollout-closing-dashboard-novo',
  homeAssessmentSlotBasedScheduling = 'centralized-ops-24-03-rollout-slot-based-assessment-scheduling-for-seller',
  assessmentStepsSot = 'seller-24-06-assessment-steps-sot',
  finalOfferNovo = 'seller-24-06-rollout-final-offer-novo',
}
// Note: These are the flags we're fetching on the experimentation context aka app load
export const AMPLITUDE_CONTEXT_FFS: Record<AMPLITUDE_CONTEXT_FLAGS_LIST, { defaultValue: string }> =
  {
    [AMPLITUDE_CONTEXT_FLAGS_LIST.homebuilderExtendedCloseOfEscrow]: {
      defaultValue: 'off',
    },
    [AMPLITUDE_CONTEXT_FLAGS_LIST.closingDashboardNovo]: {
      defaultValue: 'off',
    },
    [AMPLITUDE_CONTEXT_FLAGS_LIST.homeAssessmentSlotBasedScheduling]: {
      defaultValue: 'off',
    },
    [AMPLITUDE_CONTEXT_FLAGS_LIST.assessmentStepsSot]: {
      defaultValue: 'off',
    },
    [AMPLITUDE_CONTEXT_FLAGS_LIST.finalOfferNovo]: {
      defaultValue: 'off',
    },
  };

/** Exporting the values we are expecting from amplitude to be checked in the experimentation context */
export const ENUM_FLAG_VALUES = {
  ON: 'on',
};

/**
 * NOTE: If you want your feature flags to run in the Opendoor mobile app, you
 * need to add it to the whitelist below. Please test your feature flags in the
 * mobile app before adding it below to make sure it behaves as intended.
 * Instructions here: https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2317353092/Experimentation+Feature+Flagging+With+Amplitude#How-to-test-that-your-FF/Experiment-is-showing-up-on-WebViews
 */
export const WEBVIEW_FEATURE_FLAGS_ALLOWLIST: string[] = [
  AMPLITUDE_CONTEXT_FLAGS_LIST.closingDashboardNovo,
  AMPLITUDE_CONTEXT_FLAGS_LIST.homeAssessmentSlotBasedScheduling,
  agentLedAssessments,
  AMPLITUDE_CONTEXT_FLAGS_LIST.assessmentStepsSot,
];

export const WEBVIEW_FF_OPT_OUT_LIST: string[] = [
  AMPLITUDE_CONTEXT_FLAGS_LIST.homebuilderExtendedCloseOfEscrow,
  AMPLITUDE_CONTEXT_FLAGS_LIST.finalOfferNovo,
  coreExpNovoAuth,
];

/**
 * Helps us keep track of all the FFs in the app
 */
export const AMPLITUDE_FF_LIST = [...Object.values(AMPLITUDE_CONTEXT_FLAGS_LIST)];
